import { useParams } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import {Link} from 'react-router-dom';

function Hoteldetails() {  
    const { id } = useParams();
    const [hDetails,setUsers]=useState({})
    const userDetails = () => {

        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                // 'Authorization': `Bearer qwertyuiopasdfghjklzxcvbnm123456`, // notice the Bearer before your token
            },
        };
        
        fetch(`https://travelapp-8fhf.onrender.com/hotel_details/${id}`, requestOptions)
        .then(response => {
            return response.json()
        })
        .then(data => {
            setUsers(data)
        })
    }

    useEffect(() => {
        userDetails();
    }); 

    return (
        <>
        {   hDetails[0] != null ? 

            <section className="hoteldetsils">
                <picture>
                    {hDetails[0].photo.map(element => ( 
                        <img src={element} alt="" />
                    ))}
                </picture>
                <h1>{hDetails[0].name} <small><Link to={'/details/'+hDetails[0].location_id}>{hDetails[0].location}</Link></small></h1>
                <p>{hDetails[0].desc}</p>
            </section>:null
        }
        </>
        );
    }
  
export default Hoteldetails;